"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  blurEditor: function blurEditor() {
    return _blurEditor;
  },
  deselectEditor: function deselectEditor() {
    return _deselectEditor;
  },
  findEditorDocumentOrShadowRoot: function findEditorDocumentOrShadowRoot() {
    return _findEditorDocumentOrShadowRoot;
  },
  findEventRange: function findEventRange() {
    return _findEventRange;
  },
  findNodeKey: function findNodeKey() {
    return _findNodeKey;
  },
  findNodePath: function findNodePath() {
    return _findNodePath;
  },
  focusEditor: function focusEditor() {
    return _focusEditor;
  },
  focusEditorEdge: function focusEditorEdge() {
    return _focusEditorEdge;
  },
  getEditorWindow: function getEditorWindow() {
    return _getEditorWindow;
  },
  hasEditorDOMNode: function hasEditorDOMNode() {
    return _hasEditorDOMNode;
  },
  hasEditorEditableTarget: function hasEditorEditableTarget() {
    return _hasEditorEditableTarget;
  },
  hasEditorSelectableTarget: function hasEditorSelectableTarget() {
    return _hasEditorSelectableTarget;
  },
  hasEditorTarget: function hasEditorTarget() {
    return _hasEditorTarget;
  },
  insertData: function insertData() {
    return _insertData;
  },
  isComposing: function isComposing() {
    return _isComposing;
  },
  isEditorFocused: function isEditorFocused() {
    return _isEditorFocused;
  },
  isEditorReadOnly: function isEditorReadOnly() {
    return _isEditorReadOnly;
  },
  isTargetInsideNonReadonlyVoid: function isTargetInsideNonReadonlyVoid() {
    return _isTargetInsideNonReadonlyVoid;
  },
  setFragmentData: function setFragmentData() {
    return _setFragmentData;
  },
  toDOMNode: function toDOMNode() {
    return _toDOMNode;
  },
  toDOMPoint: function toDOMPoint() {
    return _toDOMPoint;
  },
  toDOMRange: function toDOMRange() {
    return _toDOMRange;
  },
  toSlateNode: function toSlateNode() {
    return _toSlateNode;
  },
  toSlatePoint: function toSlatePoint() {
    return _toSlatePoint;
  },
  toSlateRange: function toSlateRange() {
    return _toSlateRange;
  }
});
module.exports = __toCommonJS(src_exports);

// src/react-editor/blurEditor.ts
var import_slate_react = require("slate-react");
var _blurEditor = function _blurEditor(editor) {
  return import_slate_react.ReactEditor.blur(editor);
};

// src/react-editor/deselectEditor.ts
var import_slate_react2 = require("slate-react");
var _deselectEditor = function _deselectEditor(editor) {
  return import_slate_react2.ReactEditor.deselect(editor);
};

// src/react-editor/findEditorDocumentOrShadowRoot.ts
var import_slate_react3 = require("slate-react");
var _findEditorDocumentOrShadowRoot = function _findEditorDocumentOrShadowRoot(editor) {
  try {
    return import_slate_react3.ReactEditor.findDocumentOrShadowRoot(editor);
  } catch (error) {}
};

// src/react-editor/findEventRange.ts
var import_slate_react4 = require("slate-react");
var _findEventRange = function _findEventRange(editor, event) {
  try {
    return import_slate_react4.ReactEditor.findEventRange(editor, event);
  } catch (error) {}
};

// src/react-editor/findNodeKey.ts
var import_slate_react5 = require("slate-react");
var _findNodeKey = function _findNodeKey(editor, node) {
  try {
    return import_slate_react5.ReactEditor.findKey(editor, node);
  } catch (error) {}
};

// src/react-editor/findNodePath.ts
var import_slate_react6 = require("slate-react");
var _findNodePath = function _findNodePath(editor, node) {
  try {
    return import_slate_react6.ReactEditor.findPath(editor, node);
  } catch (error) {}
};

// src/react-editor/focusEditor.ts
var import_slate = require("@udecode/slate");
var import_slate_react7 = require("slate-react");
var _focusEditor = function _focusEditor(editor, target) {
  if (target) {
    (0, import_slate.withoutNormalizing)(editor, function () {
      (0, import_slate.deselect)(editor);
      (0, import_slate.select)(editor, target);
    });
  }
  import_slate_react7.ReactEditor.focus(editor);
};

// src/react-editor/getEditorWindow.ts
var import_slate_react8 = require("slate-react");
var _getEditorWindow = function _getEditorWindow(editor) {
  try {
    return import_slate_react8.ReactEditor.getWindow(editor);
  } catch (error) {}
};

// src/react-editor/hasEditorDOMNode.ts
var import_slate_react9 = require("slate-react");
var _hasEditorDOMNode = function _hasEditorDOMNode(editor, target, options) {
  try {
    return import_slate_react9.ReactEditor.hasDOMNode(editor, target, options);
  } catch (error) {}
  return false;
};

// src/react-editor/hasEditorEditableTarget.ts
var import_slate_react10 = require("slate-react");
var _hasEditorEditableTarget = function _hasEditorEditableTarget(editor, target) {
  try {
    return import_slate_react10.ReactEditor.hasEditableTarget(editor, target);
  } catch (error) {}
  return false;
};

// src/react-editor/hasEditorSelectableTarget.ts
var import_slate_react11 = require("slate-react");
var _hasEditorSelectableTarget = function _hasEditorSelectableTarget(editor, target) {
  try {
    return import_slate_react11.ReactEditor.hasSelectableTarget(editor, target);
  } catch (error) {}
  return false;
};

// src/react-editor/hasEditorTarget.ts
var import_slate_react12 = require("slate-react");
var _hasEditorTarget = function _hasEditorTarget(editor, target) {
  try {
    return import_slate_react12.ReactEditor.hasTarget(editor, target);
  } catch (error) {}
  return false;
};

// src/react-editor/insertData.ts
var import_slate_react13 = require("slate-react");
var _insertData = function _insertData(editor, data) {
  return import_slate_react13.ReactEditor.insertData(editor, data);
};

// src/react-editor/isComposing.ts
var import_slate_react14 = require("slate-react");
var _isComposing = function _isComposing(editor) {
  return import_slate_react14.ReactEditor.isComposing(editor);
};

// src/react-editor/isEditorFocused.ts
var import_slate_react15 = require("slate-react");
var _isEditorFocused = function _isEditorFocused(editor) {
  return import_slate_react15.ReactEditor.isFocused(editor);
};

// src/react-editor/isEditorReadOnly.ts
var import_slate_react16 = require("slate-react");
var _isEditorReadOnly = function _isEditorReadOnly(editor) {
  return import_slate_react16.ReactEditor.isReadOnly(editor);
};

// src/react-editor/isTargetInsideNonReadonlyVoidEditor.ts
var import_slate_react17 = require("slate-react");
var _isTargetInsideNonReadonlyVoid = function _isTargetInsideNonReadonlyVoid(editor, target) {
  try {
    return import_slate_react17.ReactEditor.isTargetInsideNonReadonlyVoid(editor, target);
  } catch (error) {}
  return false;
};

// src/react-editor/setFragmentData.ts
var import_slate_react18 = require("slate-react");
var _setFragmentData = function _setFragmentData(editor, data) {
  return import_slate_react18.ReactEditor.setFragmentData(editor, data);
};

// src/react-editor/toDOMNode.ts
var import_slate_react19 = require("slate-react");
var _toDOMNode = function _toDOMNode(editor, node) {
  try {
    return import_slate_react19.ReactEditor.toDOMNode(editor, node);
  } catch (error) {}
};

// src/react-editor/toDOMPoint.ts
var import_slate_react20 = require("slate-react");
var _toDOMPoint = function _toDOMPoint(editor, point) {
  try {
    return import_slate_react20.ReactEditor.toDOMPoint(editor, point);
  } catch (error) {}
};

// src/react-editor/toDOMRange.ts
var import_slate_react21 = require("slate-react");
var _toDOMRange = function _toDOMRange(editor, range) {
  try {
    return import_slate_react21.ReactEditor.toDOMRange(editor, range);
  } catch (error) {}
};

// src/react-editor/toSlateNode.ts
var import_slate_react22 = require("slate-react");
var _toSlateNode = function _toSlateNode(editor, domNode) {
  try {
    return import_slate_react22.ReactEditor.toSlateNode(editor, domNode);
  } catch (error) {}
};

// src/react-editor/toSlatePoint.ts
var import_slate_react23 = require("slate-react");
var _toSlatePoint = function _toSlatePoint(editor, domPoint, options) {
  try {
    return import_slate_react23.ReactEditor.toSlatePoint(editor, domPoint, options);
  } catch (error) {}
};

// src/react-editor/toSlateRange.ts
var import_slate_react24 = require("slate-react");
var _toSlateRange = function _toSlateRange(editor, domRange, options) {
  try {
    return import_slate_react24.ReactEditor.toSlateRange(editor, domRange, options);
  } catch (error) {}
};

// src/utils/focusEditorEdge.ts
var import_slate2 = require("@udecode/slate");
var _focusEditorEdge = function _focusEditorEdge(editor) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$edge = _ref.edge,
    edge = _ref$edge === void 0 ? "start" : _ref$edge;
  var target = edge === "start" ? (0, import_slate2.getStartPoint)(editor, []) : (0, import_slate2.getEndPoint)(editor, []);
  _focusEditor(editor, target);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  blurEditor: _blurEditor,
  deselectEditor: _deselectEditor,
  findEditorDocumentOrShadowRoot: _findEditorDocumentOrShadowRoot,
  findEventRange: _findEventRange,
  findNodeKey: _findNodeKey,
  findNodePath: _findNodePath,
  focusEditor: _focusEditor,
  focusEditorEdge: _focusEditorEdge,
  getEditorWindow: _getEditorWindow,
  hasEditorDOMNode: _hasEditorDOMNode,
  hasEditorEditableTarget: _hasEditorEditableTarget,
  hasEditorSelectableTarget: _hasEditorSelectableTarget,
  hasEditorTarget: _hasEditorTarget,
  insertData: _insertData,
  isComposing: _isComposing,
  isEditorFocused: _isEditorFocused,
  isEditorReadOnly: _isEditorReadOnly,
  isTargetInsideNonReadonlyVoid: _isTargetInsideNonReadonlyVoid,
  setFragmentData: _setFragmentData,
  toDOMNode: _toDOMNode,
  toDOMPoint: _toDOMPoint,
  toDOMRange: _toDOMRange,
  toSlateNode: _toSlateNode,
  toSlatePoint: _toSlatePoint,
  toSlateRange: _toSlateRange
});